export default "__VITE_ASSET__C3sHKG6E__"